import { useHelpCenter } from 'hooks/use-help-center';
import { useMemo } from 'react';

export function useHelpCenterFactsheetLink(productType?: string, productSubType?: string) {
  const { getTopicById } = useHelpCenter();

  const topic = useMemo(
    () => (productType && productSubType ? getTopicById(`${productType}.${productSubType}`) : undefined),
    [productSubType, productType, getTopicById],
  );

  const link = useMemo(() => {
    if (!topic?.content) {
      return undefined;
    }

    const match = topic.content.match(/<tutorial-pdf-download url="([^"]+)"/);
    return match?.[1];
  }, [topic]);

  return link;
}
